import RadioButtonField from "../../../Utils/RadioButtonField"
import { careerProfileLabels } from "../../../Types/careerProfileLabels"
import EditorField from "../../../Utils/EditorField"
import Conviction from "./Conviction"
import styles from "../../../../../styles/Participant-Employment.module.css"
import { Button } from "primereact/button"
import { deleteConfirmationModal } from "../../../Utils/formikAux"
import TextField from "../../../Utils/TextField"
import PhoneField from "../../../Utils/PhoneField"
import { getFormErrorMessage } from "../../../Utils/formikAux"
const LegalHistory = ({
  formik,
  setEditConviction,
  setConvictionFormVisible,
  setDeleteConviction,
  convictionFormVisible,
  deleteConviction,
  editConviction,
}) => {
  const convictionsTable = () => {
    return (
      <table
        className={styles.table}
        style={{
          marginBottom: "1rem",
          paddingTop: "17px",
          paddingLeft: "16px",
          paddingBottom: "23px",
          paddingRight: "15px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Year
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Type of conviction
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Sentence/Disposition
            </th>
          </tr>
        </thead>
        <tbody>
          {formik.values.legal_convictions.map((e) => {
            return (
              <tr key={e.id}>
                <td>{e.year}</td>
                <td>{e.type}</td>
                <td>{e.sentence}</td>
                <td
                  style={{
                    textAlign: "center",
                    width: "80px",
                    paddingRight: "1rem",
                  }}
                >
                  {
                    <div className={styles.table_actions}>
                      <Button
                        icon="pi pi-pencil"
                        className={styles.rounded_btn}
                        type="button"
                        onClick={() => {
                          setEditConviction(e)
                          setConvictionFormVisible(true)
                        }}
                      />
                      <Button
                        icon="pi pi-trash"
                        className={styles.rounded_btn}
                        type="button"
                        onClick={() => {
                          setDeleteConviction(e.id)
                        }}
                      />
                    </div>
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      //agregar aqui el boton para abrir el form
    )
  }
  const removeConviction = (id) => {
    formik.setFieldValue(
      "legal_convictions",
      formik.values.legal_convictions.filter((p) => p.id !== id)
    )
  }
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.legalHistory.legalHistory_1.label}
          value={formik.values.legal_1}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.legalHistory.legalHistory_1.value}
          long
          callback={(value) => {
            if (value !== "Yes") {
              formik.setFieldValue("legal_convictions", [])
            }
          }}
        />
      </div>
      <Conviction
        setVisible={setConvictionFormVisible}
        visible={convictionFormVisible}
        edit={editConviction}
        setEdit={setEditConviction}
        setValue={formik.setFieldValue}
        jobs={formik.values.legal_convictions}
      />
      {formik.values.legal_1 === "Yes" && (
        <div className={styles.education_wrapper}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <label
              style={{
                paddingTop: "5px",
                fontSize: "16px",
                fontWeight: "600",
                color: "#383838",
                width: "60%",
              }}
            >
              Past convictions
            </label>
            <Button
              className={styles.button}
              style={{ height: "38px" }}
              label="Add new conviction"
              onClick={() => {
                setConvictionFormVisible(true)
              }}
              type="button"
            />
          </div>
          {formik.values.legal_convictions?.length > 0 && convictionsTable()}
        </div>
      )}
      {deleteConfirmationModal(
        deleteConviction,
        setDeleteConviction,
        removeConviction,
        "conviction"
      )}
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.legal_2}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.legalHistory.legalHistory_2.value}
          label={careerProfileLabels.legalHistory.legalHistory_2.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.legalHistory.legalHistory_3.label}
          value={formik.values.legal_3}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.legalHistory.legalHistory_3.value}
          long
        />
      </div>
      {formik.values.legal_3 === "Yes" && (
        <>
          <TextField
            label={careerProfileLabels.legalHistory.legalHistory_3a.label}
            setValue={formik.setFieldValue}
            valueName={careerProfileLabels.legalHistory.legalHistory_3a.value}
            value={formik.values.legal_3a}
          />
          <div style={{ marginTop: "10px" }}>
            <PhoneField
              label={careerProfileLabels.legalHistory.legalHistory_3b.label}
              setValue={formik.setFieldValue}
              valueName={careerProfileLabels.legalHistory.legalHistory_3b.value}
              value={formik.values.legal_3b}
            />
          </div>
          <TextField
            label={careerProfileLabels.legalHistory.legalHistory_3c.label}
            setValue={formik.setFieldValue}
            value={formik.values.legal_3c}
            valueName={careerProfileLabels.legalHistory.legalHistory_3c.value}
            error={getFormErrorMessage(
              careerProfileLabels.legalHistory.legalHistory_3c.value,
              formik
            )}
          />
        </>
      )}
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.legalHistory.legalHistory_4.label}
          value={formik.values.legal_4}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.legalHistory.legalHistory_4.value}
        />
      </div>
      {formik.values.legal_4 === "No" && (
        <div style={{ marginTop: "20px" }}>
          <RadioButtonField
            label={careerProfileLabels.legalHistory.legalHistory_4a.label}
            value={formik.values.legal_4a}
            setValue={formik.setFieldValue}
            valueName={careerProfileLabels.legalHistory.legalHistory_4a.value}
            short
          />
        </div>
      )}
    </>
  )
}
export default LegalHistory
